import { View, Text, ImageBackground, Image } from "react-native";
import React from "react";
import { isSmallScreen } from "../constants";

const GernericEventBackground = ({
  showLogo = true,
}: {
  showLogo?: boolean;
}) => {
  return (
    <ImageBackground
      source={require("assets/images/event-general.jpg")}
      style={{
        borderRadius: 15,
        width: "100%",
        height: isSmallScreen ? 200 : 275,
        overflow: "hidden",
      }}
    >
      {showLogo && (
        <>
          <View className="bg-[#2c5f83] absolute w-36 h-36 -bottom-20 -left-20 md:w-48 md:h-48 md:-bottom-24 md:-left-24 rotate-45"></View>
          <View className="absolute bottom-4 left-4 w-6 h-6 md:w-10 md:h-10">
            <Image
              source={require("assets/images/fanRally_logo_white.svg")}
              style={{
                width: "100%",
                height: "100%",
              }}
            />
          </View>
        </>
      )}
    </ImageBackground>
  );
};

export default GernericEventBackground;
